import { render } from "./AtomButton.vue?vue&type=template&id=2fbdb200&scoped=true&ts=true"
import script from "./AtomButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomButton.vue?vue&type=script&lang=ts&setup=true"

import "./AtomButton.vue?vue&type=style&index=0&id=2fbdb200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbdb200"],['__file',"src/components/atoms/AtomButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fbdb200"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fbdb200', __exports__)) {
    api.reload('2fbdb200', __exports__)
  }
  
  module.hot.accept("./AtomButton.vue?vue&type=template&id=2fbdb200&scoped=true&ts=true", () => {
    api.rerender('2fbdb200', render)
  })

}


export default __exports__